import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import map from 'lodash/map';
import queryString from 'query-string';

import mediator, { ACTIONS } from 'mediator';

import features from 'lib/common/features';
import collectSeats from 'lib/seatmaps/collectSeats';
import collectZonesByLevel from 'lib/seatmaps/collectZonesByLevel';
import panZoom from 'behaviours/panZoom';
import { setLevel, animateMap } from 'behaviours/animateMap';
import enhanceSeats from 'behaviours/enhanceSeats';
import changeScreen from 'behaviours/changeScreen';

import BackButton from 'components/BackButton';
import SeatMap from 'components/SeatMap';
import ZoomControls from 'components/ZoomControls';
import SingleSeatWarning from 'components/SingleSeatWarning';
import DropShadowFilter from 'components/DropShadowFilter';

class SeatMapContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      panZoomInstance: null,
      loading: true,
      hasContiguousSeats: true
    };

    this.collectLevelDetails = this.collectLevelDetails.bind(this);
  }

  componentDidMount() {
    let { svgEl, levelEls } = this._seatMapRefs;

    if (!this.props.usesGeneratedSeatmap && levelEls.length) {
      animateMap(svgEl, levelEls);
      let params = queryString.parse(window.location.search);
      if (this.props.selectedLevel) {
        mediator.publish(
          ACTIONS.LEVEL_SELECTED,
          this.props.selectedLevel.selector
        );
      } else if (params && params.layer) {
        setLevel(params.layer);
      }
    }

    this.setState({ loading: true });
    let zoomControlsOptions = features.getOption('panZoom', 'options');
    if (svgEl && zoomControlsOptions) {
      let panZoomInstance = panZoom(svgEl, zoomControlsOptions);
      this.setState({ panZoomInstance: panZoomInstance });
      this.props.onPanZoomInit(panZoomInstance);
    }
  }

  componentDidUpdate() {
    let shouldRenderSeatMap =
      !this.props.isEnhanced &&
      this.props.seatData.length &&
      this._seatMapRefs.seatEls.length &&
      !this.isProcessingData;

    if (shouldRenderSeatMap) {
      this.isProcessingData = true;
      collectSeats(this._seatMapRefs.seatEls, this.props.seatData).then(
        collectedSeats => {
          this.setState({
            loading: false,
            hasContiguousSeats: collectedSeats.areContiguous
          });

          let seats = collectedSeats.seats;

          seats = enhanceSeats(seats, this.props.colours, this.props.prices);

          changeScreen(this._seatMapRefs.svgEl);

          let zonesByLevel = collectZonesByLevel(seats);

          this.props.onSeatMapReady(
            seats,
            zonesByLevel,
            this.collectLevelDetails(this._seatMapRefs.levelEls)
          );

          this.isProcessingData = false;
        }
      );
    }
  }

  collectLevelDetails(levelEls) {
    if (levelEls.length) {
      return map(levelEls, function(el) {
        return {
          el: el,
          isAvailable:
            el.querySelectorAll('.seat:not(.seat--killed)').length > 0,
          label: el.getAttribute('data-name') || el.id
        };
      });
    }
  }

  render() {
    const visibilityStyles = !this.props.seatMapReady
      ? { visibility: 'hidden' }
      : null;

    return (
      <div
        className={classnames({
          'syos-seatmap-container': true,
          'has-graphic-seatmap':
            this.props.isEnhanced && !this.props.usesGeneratedSeatmap,
          'has-back-button':
            features.isEnabled('backButton') && this.props.returnUrl !== undefined
        })}
        style={visibilityStyles}
      >
        {features.isEnabled('backButton') && this.props.returnUrl ? (
          <BackButton returnUrl={this.props.returnUrl} />
        ) : null}

        {features.isEnabled('panZoom') && this.state.panZoomInstance ? (
          <ZoomControls panZoomInstance={this.state.panZoomInstance} />
        ) : null}

        {features.isEnabled('layerShadow') ? (
          <DropShadowFilter
            direction={features.getOption('layerShadow', 'direction') || 'Up'}
          />
        ) : null}

        {this.state.hasContiguousSeats === false ? <SingleSeatWarning /> : null}

        <SeatMap
          svgData={this.props.svgData}
          isEnhanced={this.props.isEnhanced}
          ref={component => {
            this._seatMapRefs = component && {
              el: component._seatmap,
              svgEl: component._seatmapSvg,
              seatEls: component._seats,
              levelEls: component._levels
            };
          }}
        />
      </div>
    );
  }
}

SeatMapContainer.propTypes = {
  usesGeneratedSeatmap: PropTypes.bool,
  svgData: PropTypes.string.isRequired,
  seatData: PropTypes.arrayOf(PropTypes.object),
  isEnhanced: PropTypes.bool,
  selectedLevel: PropTypes.object,
  seatMapReady: PropTypes.bool,
  onPanZoomInit: PropTypes.func,
  onSeatMapReady: PropTypes.func,
  colours: PropTypes.array,
  returnUrl: PropTypes.string,
  prices: PropTypes.array,
  additionalPrices: PropTypes.array,
};

export default SeatMapContainer;



// WEBPACK FOOTER //
// ./src/javascripts/containers/SeatMapContainer.js